import React, { Fragment, memo } from 'react'
import startCase from 'lodash/startCase'
import { Typography, makeStyles } from 'transfix-ui/core'
import { DISPLAY } from 'constants/display'
import { IShipperContact } from '../utils/normalizeShipperContacts'
import { ContactEmails } from './ContactEmails'
import { ContactPhone } from './ContactPhone'

interface IContactRowProps {
  contact: IShipperContact
}

const useContactRowStyles = makeStyles(({ spacing }) => ({
  caption: {
    marginLeft: spacing(0.5),
  },
}))

export const ContactRow = memo<IContactRowProps>(({ contact }) => {
  const classes = useContactRowStyles()
  const { caption, ediEmails, email, name, notes, phone, phoneExtension, role, secondaryEmail } =
    contact || {}
  return (
    <>
      <Typography variant='body1'>
        {name || DISPLAY.empty}
        {caption && (
          <Typography variant='caption' color='textSecondary' className={classes.caption}>
            {caption}
          </Typography>
        )}
      </Typography>
      <Typography variant='body1'>{startCase(role.toString()) || DISPLAY.empty}</Typography>
      <ContactEmails email={email} secondaryEmail={secondaryEmail} ediEmails={ediEmails} />
      <ContactPhone phone={phone} phoneExtension={phoneExtension} />
      <Typography variant='body1'>{notes || DISPLAY.empty}</Typography>
    </>
  )
})
